import cn from 'classnames';
import { useSuspenseLighthousesCount } from '#api/lighthouses.queries.ts';
import { LinkButton } from '#components/atoms/buttons/link-button/LinkButton.tsx';
import { CenteredLayout } from '#components/patterns/layouts/centered/CenteredLayout.tsx';

type Props = {
  addHostHref: string;
};

/**
 * {@link EmptyHosts} is an empty state for the hosts page, giving the user a CTA to add a host or clear filters.
 */
export function EmptyHosts({ addHostHref }: Props) {
  const hasLighthouse = useSuspenseLighthousesCount().data > 0;

  return (
    <CenteredLayout>
      <div>
        <h2 className="h3 mb-16">You don’t have any hosts set up</h2>
        <p className={cn('p-lt', { 'mb-24': hasLighthouse })}>
          Create and enroll a{' '}
          <a className="a" href="https://www.defined.net/docs/glossary/host/" target="_blank" rel="help">
            host
          </a>{' '}
          to begin using it in your network.
        </p>
        {hasLighthouse ? null : (
          <p className="p-lt mb-24">
            Be sure to also create and enroll a lighthouse, or your hosts won’t be able to find each other.
          </p>
        )}
        <LinkButton to={addHostHref}>Add host</LinkButton>
      </div>
    </CenteredLayout>
  );
}
